import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export const gerarPDFSlides = async () => {
  const pdfWidth = 297; // mm, slide horizontal
  const pdfHeight = 167; // mm
  const pdf = new jsPDF({ orientation: 'l', unit: 'mm', format: [pdfWidth, pdfHeight] });

  // 🔹 Slides de introdução (fixos, sobre a empresa)
  const introSlides = [
    '/1.png',
    '/2.png',
    '/3.png',
  ];

  let first = true;

  // Renderiza os slides fixos
  for (const src of introSlides) {
    const img = new Image();
    img.src = src;
    await new Promise(resolve => { img.onload = resolve; });

    if (!first) pdf.addPage();
    pdf.addImage(img, 'PNG', 0, 0, pdfWidth, pdfHeight);

    first = false;
  }

  // 🔹 Agora pega os slides reais (DOM)
  const slides = document.querySelectorAll<HTMLElement>('.pdf-slide'); 
  if (slides.length === 0) return;

  // Carrega a borda
  const bordaImg = new Image();
  bordaImg.src = '/Unico - ZN - V1.pptx.png';
  await new Promise(resolve => { bordaImg.onload = resolve; });

  for (const slide of slides) {
    const canvas = await html2canvas(slide, { scale: 2 });
    const imgData = canvas.toDataURL('image/png');
    const imgProps = pdf.getImageProperties(imgData);

    let imgWidth = pdfWidth;
    let imgHeight = (imgProps.height * pdfWidth) / imgProps.width;
    if (imgHeight > pdfHeight) {
      imgHeight = pdfHeight;
      imgWidth = (imgProps.width * pdfHeight) / imgProps.height;
    }
    const xOffset = (pdfWidth - imgWidth) / 2;
    const yOffset = (pdfHeight - imgHeight) / 2;

    pdf.addPage();
    pdf.addImage(imgData, 'PNG', xOffset, yOffset, imgWidth, imgHeight);
    pdf.addImage(bordaImg, 'PNG', 0, 0, pdfWidth, pdfHeight);
  }

  pdf.save('dashboard.pdf');
};
